import { LineItemReturnModel as LineItem, ProductCardModel, ProductModel } from '../services/client.generated';


export namespace instanceOf {
    export function lineItem(object: any): object is LineItem {

        return 'id' in object &&
            'name' in object &&
            // 'googleProductCategory' in object &&
            'productUrl' in object &&
            'totalPrice' in object &&
            'quantity' in object;
    }
    export function productCardModel(object: any): object is ProductCardModel {

        return 'id' in object &&
            'name' in object &&
            // 'googleProductCategory' in object &&
            'price' in object;
    }
    export function productModel(object: any): object is ProductModel {

        return 'id' in object &&
            'name' in object &&
            // 'googleProductCategory' in object &&
            'description' in object &&
            'price' in object;
    }
}
